/* eslint-disable react/no-unstable-nested-components */
import classNames from "components/ui/classNames";
import { ArrowDown10Icon, ArrowUp01Icon, ArrowUpDownIcon } from "lucide-react";
import type { HTMLAttributes } from "react";
interface ToggleSortingButtonProps extends HTMLAttributes<HTMLButtonElement> {
  sortDirection: "ASC" | "DESC" | null;
}
export default function ToggleSortingButton({ sortDirection, ...props }: ToggleSortingButtonProps) {
  return (
    <button
      {...props}
      type="button"
      className={classNames(
        "rounded-xl border border-slate-200 bg-slate-50/60 p-2 text-slate-600",
        "dark:border-slate-950 dark:bg-slate-700 dark:text-slate-300",
        {
          "bg-violet-50 text-violet-600 dark:bg-violet-600/20 dark:text-violet-200": sortDirection !== null,
        },
        "focus-visible:outline-none",
        "focus-visible:ring-1 focus-visible:ring-offset-1",
        "focus-visible:ring-gray-100 focus-visible:ring-offset-gray-300",
        "focus-visible:border-transparent focus-visible:bg-gray-50 focus-visible:text-gray-600",
        "dark:focus-visible:ring-slate-950 dark:focus-visible:ring-offset-transparent",
      )}
    >
      {sortDirection === "DESC" && <ArrowDown10Icon strokeWidth={1.5} />}
      {sortDirection === "ASC" && <ArrowUp01Icon strokeWidth={1.5} />}
      {!sortDirection && <ArrowUpDownIcon strokeWidth={1.5} />}
    </button>
  );
}
